const TrayRegistry = new Map()
const MenuItemRegistry = new Map()
const shownElements = new Set()

const closeDelayMS = 500

/* globals IntersectionObserver */

function setupMegaMenu () {
  // console.log('Setup Mega Menu!')
  let closingTimerInstance = null
  const megaMenuRoot = document.querySelector('.mega-menu--js-handle')

  const isElementHidden = element => {
    return element.getAttribute('aria-hidden') === 'true'
  }

  const onEnterTray = event => {
    // console.log('Enter Tray!', { event })
    if (closingTimerInstance) {
      clearTimeout(closingTimerInstance)
    }
  }
  const onLeaveTray = event => {
    const { target } = event
    const trayID = target.getAttribute('data-tray-id')
    if (TrayRegistry.has(trayID)) {
      const trayControlInstance = TrayRegistry.get(trayID)
      closingTimerInstance = setTimeout(() => {
        trayControlInstance.hide()
      }, closeDelayMS)
    }
  }

  const onEnterMenuItem = (event, itemID) => {
    if (closingTimerInstance) {
      clearTimeout(closingTimerInstance)
    }
    // console.log('Enter Menu Item', { event, itemID })
  }

  const onLeaveMenuItem = event => {
    // console.log('Leave Menu Item', { event })
  }

  const hideElement = element => {
    if (shownElements.has(element)) {
      // console.log({ hide: element })
      const trayId = element.dataset.trayId
      const menuItemElement = MenuItemRegistry.get(trayId)

      menuItemElement.classList.remove('mega-menu__item--active')

      shownElements.delete(element)
      element.setAttribute('aria-hidden', 'true')
      element.hidden = true
      element.removeEventListener('pointerenter', onEnterTray)
      element.removeEventListener('pointerleave', onLeaveTray)
    }
  }

  const showElement = element => {
    if (shownElements.has(element) === false) {
      const trayId = element.dataset.trayId
      const menuItemElement = MenuItemRegistry.get(trayId)
      const parentOffset = element.parentElement.offsetLeft
      const leftOffset = menuItemElement.offsetLeft - parentOffset
      // console.log({ trayId, leftOffset })

      menuItemElement.classList.add('mega-menu__item--active')

      element.setAttribute('aria-hidden', 'false')
      element.hidden = false
      element.style.transform = `translateX(${leftOffset}px)`
      shownElements.add(element)
      element.addEventListener('pointerenter', onEnterTray)
      element.addEventListener('pointerleave', onLeaveTray)
    }
  }

  const makeToggler = element => () => {
    for (const shownElement of shownElements.values()) {
      if (element !== shownElements) {
        hideElement(shownElement)
      }
    }
    if (isElementHidden(element)) {
      showElement(element)
    } else {
      hideElement(element)
    }
  }

  const makeShower = element => () => {
    showElement(element)
  }

  const makeHider = element => () => {
    hideElement(element)
  }

  if (megaMenuRoot) {
    setupStickyObserver(megaMenuRoot)
    const menuItemsWithChildren = megaMenuRoot.querySelectorAll(':scope .mega-menu__item--js-handle')
    const menuTrays = megaMenuRoot.querySelectorAll(':scope .mega-menu__tray--js-handle')
    // For each menu item
    for (const menuItem of menuItemsWithChildren) {
      const { itemId } = menuItem.dataset
      if (MenuItemRegistry.has(itemId) === false) {
        MenuItemRegistry.set(itemId, menuItem)
        menuItem.addEventListener('pointerover', event => {
          if (TrayRegistry.has(itemId)) {
            onEnterMenuItem(event, itemId)
            // console.log(`ENTER MENU ITEM: ${itemId}`)
            const {
              toggle
              // show
            } = TrayRegistry.get(itemId)
            // show()
            toggle()
          }
        })
        menuItem.addEventListener('pointerleave', (event) => {
          if (TrayRegistry.has(itemId)) {
            onLeaveMenuItem(event, itemId)
            // console.log(`LEAVE MENU ITEM: ${itemId}`)
            const trayControlInstance = TrayRegistry.get(itemId)
            closingTimerInstance = setTimeout(() => {
              trayControlInstance.hide()
            }, closeDelayMS / 2)
          }
        })
      }
    }
    // for each tray item
    for (const trayItem of menuTrays) {
      const { trayId } = trayItem.dataset
      if (TrayRegistry.has(trayId) === false) {
        TrayRegistry.set(trayId, {
          trayId,
          trayItem,
          toggle: makeToggler(trayItem),
          show: makeShower(trayItem),
          hide: makeHider(trayItem)
        })
      }
    }
    setupSubmenus(megaMenuRoot)
  }
}

function setupSubmenus (megaMenuRoot) {
  const shownElements = new Set()
  const activeMenuDepth = 0
  function showSubmenu (element, relativeElement) {
    const menuLevel = element.dataset.menuLevel
    // element.style.display = 'block'
    if (shownElements.has(element) === false) {
      console.log({ menuLevel })
      element.style.display = 'block'
      element.style.left = `${relativeElement.clientLeft + relativeElement.clientWidth}px`
      shownElements.add(element)
    }
  }
  function hideSubmenu (element) {
    if (shownElements.has(element)) {
      element.style.display = 'none'
      shownElements.delete(element)
    }
  }
  const regularMenuElements = megaMenuRoot.querySelectorAll(':scope .mega-menu__tray-item--without-children')
  for (const regularMenuElement of regularMenuElements) {
    const linkElement = regularMenuElement.querySelector(':scope a')
    linkElement.addEventListener('pointerenter', event => {
      if (event.relatedTarget.parentElement && event.relatedTarget.parentElement.parentElement) {
        const grandparent = event.relatedTarget.parentElement.parentElement
        if (grandparent !== regularMenuElement) {
          // hideSubmenu(regularMenuElement)
          // console.log(grandparent)
          // console.log('LEAVE', regularMenuElement)
          console.log('enter regular item')
        }
      }
    })
  }
  const subMenuElements = megaMenuRoot.querySelectorAll(':scope .mega-menu__tray-item--with-children')
  for (const subMenuElement of subMenuElements) {
    const linkElement = subMenuElement.querySelector(':scope a')
    const submenuList = subMenuElement.querySelector(':scope ul')
    const parentText = linkElement.innerText
    linkElement.addEventListener('pointerenter', event => {
      // console.log('ENTER', parentText)
      // console.log({ submenuList, menuLevel })
      showSubmenu(submenuList, linkElement)
    })
    linkElement.addEventListener('pointerleave', event => {
      if (event.relatedTarget.parentElement && event.relatedTarget.parentElement.parentElement) {
        const grandparent = event.relatedTarget.parentElement.parentElement
        if (grandparent !== submenuList) {
          hideSubmenu(submenuList)
          // console.log(grandparent)
          console.log('LEAVE', parentText)
        }
      }
    })
    // console.log({ subMenuElement, linkElement, parentText })
  }
}

function setupStickyObserver (rootMenuElement) {
  const UniversityBlackTopBarElement = document.querySelector('.cmp-university-header')
  const UgaLawHeaderElement = document.querySelector('.uga-law-header--js-handle')
  if (UniversityBlackTopBarElement) {
    console.log('Found UGA Black Top Bar')
  } else {
    console.log('UGA Black Top Bar Not Found.')
  }
  console.log('Setup Sticky Observer for:', rootMenuElement)
  if ('IntersectionObserver' in window) {
    // console.log({ IntersectionObserver })
    if (UniversityBlackTopBarElement) {
      const stickyWatcher = new IntersectionObserver(observer => {
        for (const entry of observer) {
          // console.log({ entry })
          if (entry.intersectionRatio <= 0) {
            rootMenuElement.classList.add('mega-menu--floating')
            UgaLawHeaderElement.classList.add('uga-law-header--floating')
          } else {
            rootMenuElement.classList.remove('mega-menu--floating')
            UgaLawHeaderElement.classList.remove('uga-law-header--floating')
          }
        }
      })
      stickyWatcher.observe(UniversityBlackTopBarElement)
    }
  } else {
    console.error('IntersectionObserver not supported by current browser.')
  }
}

// if (Drupal) {
//     Drupal.behaviors.lawfulMegaMenu = {
//         attach(context, settings) {
//             setupMegaMenu()
//         }
//     }
// } else {
//     console.log({ Drupal })
// }

// document.addEventListener('DOMContentLoaded', function () {
//   // console.log('DOMContentLoaded!!!')
//   setupMegaMenu()
// })

export function runMegaMenuLoader () {
  setupMegaMenu()
}
